import { BuzerIcon } from "../../../BuzerIcons";

// Static label / stat pill — mono, tinted, non-interactive (unlike Pill). Always
// a rounded pill. Covers the VÝZVA label (tone brand, xs), the title streak/
// percent pill (tone streak, icon flame), points (+15: tone brand [strong] filled
// / bare plain text) and the PO TERMÍNE badge (tone danger).
// tone: brand | streak | success | info | neutral | danger | outline | flame | growth.
// outline (v34) = biely priesvitný obrys na tier-farebnom profile / čitateľný neutrálny obrys inde.
// flame/growth (v34) = farby dlaždíc zo Štatistík (--stat-flame denná séria, --stat-growth perfektné dni).
// bare = transparent (plain coloured text) · strong = deeper brand fill.
// as="button" = klikací štítok (rovnaký vizuál, len s resetom natívneho tlačidla).
export function Tag({ tone = "brand", icon, size, bare = false, strong = false, as: Comp = "span", className = "", children, ...rest }) {
  const cls = [
    "bz-tag", `bz-tag--${tone}`,
    size === "xs" && "bz-tag--xs",
    bare && "bz-tag--bare",
    strong && "bz-tag--strong",
    Comp === "button" && "bz-tag--action",
    className,
  ].filter(Boolean).join(" ");
  const glyph = size === "xs" ? 11 : 13;
  return (
    <Comp type={Comp === "button" ? "button" : undefined} className={cls} {...rest}>
      {icon && <BuzerIcon name={icon} size={glyph} color="currentColor" />}
      {children}
    </Comp>
  );
}
